import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import RemoveIcon from '@mui/icons-material/Remove'
import React from 'react'
import { Error } from '@mui/icons-material'
import Colors from 'utils/Colors'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye'
import { Tooltip } from '@mui/material'

export const showErrorIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
  <Error fontSize={fontSize} style={{ color: Colors.errorYellow, ...style }} />
)

export const showWaitingIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
  <AccessTimeIcon fontSize={fontSize} style={{ color: Colors.waitingGray, ...style }} />
)

export const showDashIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
    <RemoveIcon fontSize={fontSize} style={{ color: Colors.waitingGray, ...style }} />
)

export const showApprovedIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
  <CheckCircleIcon fontSize={fontSize} style={{ color: Colors.approvedGreen, ...style }} />
)

export const showReprovedIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
  <CancelIcon fontSize={fontSize} style={{ color: Colors.reprovedRed, ...style }} />
)

export const showActiveGreenhouseStatus = ({ fontSize = '2rem' } = {}) => (
  <PanoramaFishEyeIcon style={{ fontSize: fontSize, color: Colors.approvedGreen }}/>
)
export const showHiredGreenhouseStatus = ({ fontSize = 'small' } = {}) => (
  <FiberManualRecordIcon size={fontSize} style={{ color: Colors.approvedGreen }}/>
)
export const showRejectedGreenhouseStatus = ({ fontSize = 'small' } = {}) => (
  <FiberManualRecordIcon size={fontSize} style={{ color: Colors.reprovedRed }}/>
)
export const showUndefinedGreenhouseStatus = ({ fontSize = '2rem' } = {}) => (
  <PanoramaFishEyeIcon style={{ fontSize: fontSize, color: Colors.gray }}/>
)

export const showGreenhouseStatusIcon = (greenhouseStatus) => {
  let icon = null
  let tip = null

  switch (greenhouseStatus) {
    case 'active':
      tip = 'Active: Em andamento'
      icon = showActiveGreenhouseStatus()
      break
    case 'rejected':
      tip = 'Rejected: Rejeitado(a)'
      icon = showRejectedGreenhouseStatus()
      break
    case 'hired':
      tip = 'Hired: Contratado(a)'
      icon = showHiredGreenhouseStatus()
      break
    default:
      tip = greenhouseStatus
      icon = showUndefinedGreenhouseStatus()
  }

  return <Tooltip arrow placement='top' title={<h4>{tip}</h4>}>
    {icon}
  </Tooltip>
}
